import { Error404 } from '@pinnacleautomotive/clarity-components';
import React from 'react';
import { useHistory } from 'react-router-dom';

const Error404Page = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push('/');
  };
  return <Error404 click={handleClick} />;
};

export default Error404Page;
